/* eslint-disable */
// Unified admin check for the Dev Settings Control Center.
//
// STRICT GATE (confirmed with David 2026-04-22):
//   Returns true when EITHER
//     - user_profiles.is_super_admin = true, OR
//     - user_portal_permissions has (user_id=me, portal_id='developments', role='admin')
//
// Editors and viewers are NOT admins. Generic admin on another portal
// (e.g. catalog or sales) does NOT grant access — Dev Settings is scoped
// to people who manage developments specifically.
//
// Fail-closed: returns false while permissions are still loading. The SQL
// RPC has its own admin gate (raises 'admin only') as defense in depth.
//
// This hook is the single replacement for the three legacy conventions
// found during Phase 1.1 discovery (role === "admin", isSuperAdmin(user),
// perm.canSettings). Inside src/components/developments/settings/, NO
// code should reach for those legacy patterns directly.

import { usePortalPermissions } from '../../../../hooks/usePortalPermissions';

export function useIsAdmin() {
  const { data, isLoading } = usePortalPermissions();

  // Fail-closed while loading
  if (isLoading) return false;
  if (!data) return false;

  // Super-admin flag wins outright
  if (data.isSuperAdmin) return true;

  // Otherwise require explicit 'admin' role on the developments portal
  const devPerm = (data.permissions || []).find(
    (p) => p.portal_id === 'developments',
  );
  return devPerm?.role === 'admin';
}
